import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import RefreshIcon from '@mui/icons-material/Refresh';

/**
 * Uniform Refresh button used at the header of every read-only list
 * page where new rows can land asynchronously — Activities, Messages,
 * Procedures, Participants, Devices, Tenants list, Crash Reports.
 *
 * Convention: each page extracts its reload logic into a single
 * `reload()` async function; the button calls it and exposes a
 * `refreshing` boolean so the icon swaps to a spinner and the button
 * disables to prevent double-clicks while a fetch is in flight.
 *
 * One component, one look — keeps the operator's muscle memory
 * consistent: same icon, same label, same position (top-right of the
 * page header strip).
 */
export function RefreshButton({
  onClick,
  refreshing,
}: {
  onClick: () => void;
  refreshing: boolean;
}) {
  return (
    <Button
      variant="outlined"
      startIcon={
        refreshing ? (
          <CircularProgress size={16} color="inherit" />
        ) : (
          <RefreshIcon />
        )
      }
      onClick={onClick}
      disabled={refreshing}
    >
      Refresh
    </Button>
  );
}
